import { useContext } from 'react';
import { TwoFAContext } from '../contexts/TwoFAContext';

export const useTwoFAData = () => useContext(TwoFAContext);
